module.exports = __webpack_public_path__ + "img/RegFees-ondemand.24af8118.svg";